import PropTypes from 'prop-types';

import SideMsg from '#/modules/commonComponents/SideMsg';
import {
  workOrderSideMsgDetailBlock,
  workOrderSideMsgStatusBlock,
} from '#/modules/momMgmt/workOrder/data/workOrderSideMsgConfig';

const WorkOrderSideMsg = ({ displayData }) => {
  const blocks = [
    workOrderSideMsgStatusBlock,
    workOrderSideMsgDetailBlock,
  ];

  return (
    <SideMsg
      title="工單"
      titleValue="workOrderNo"
      displayData={displayData}
      blocks={blocks}
    />
  );
};

WorkOrderSideMsg.propTypes = {
  displayData: PropTypes.object,
};

export default WorkOrderSideMsg;
